import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

/** A consistent titled block — eyebrow + heading + optional right-aligned aside. */
export function Section({
  title,
  eyebrow,
  aside,
  className,
  id,
  children
}: {
  title: string;
  eyebrow?: string;
  aside?: ReactNode;
  className?: string;
  id?: string;
  children: ReactNode;
}) {
  return (
    <section id={id} className={cn('pt-9', className)}>
      <div className="flex items-end justify-between gap-3 px-0.5">
        <div className="min-w-0">
          {eyebrow && (
            <div className="truncate text-[10px] font-bold uppercase tracking-eyebrow text-ink2">{eyebrow}</div>
          )}
          <h2 className={cn('text-[17px] font-extrabold tracking-tight text-ink', eyebrow && 'mt-1')}>{title}</h2>
        </div>
        {aside && <div className="max-w-[52%] shrink-0 text-right text-[12px] font-medium leading-snug text-ink2">{aside}</div>}
      </div>
      <div className="pt-3.5">{children}</div>
    </section>
  );
}
